/* @ngInject */
function ImpersonateInterceptor($injector) {
  return {
    request: function (config) {
      const SecurityManager = $injector.get("SecurityManager");
      // Si no estoy haciendo una peticion a mi servidor no meter el token.
      if (config.url.indexOf(process.env.SERVER_URL) === -1) return config;

      const impersonate = SecurityManager.getImpersonate();
      const accessToken = SecurityManager.getAccessToken();

      if (accessToken && impersonate) {
        config.headers["x-accesstoken"] = accessToken;
        config.headers["x-impersonate"] = impersonate;
      }

      return config;
    },
  };
}

export default ImpersonateInterceptor;
